import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { Lightbox } from 'ngx-lightbox';
import { EditorChangeContent, EditorChangeSelection } from 'ngx-quill';
import { Organization } from 'src/app/shared/models/organization.model';
import { SharedService } from 'src/app/shared/shared.service';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { DynamicDataService, DynamicData } from './dynamic-data.service';

@Component({
    selector: 'app-dynamic-data',
    templateUrl: './dynamic-data.component.html',
    styleUrls: ['./dynamic-data.component.css'],
    standalone: false
})
export class DynamicDataComponent implements OnInit {

  public orgId: string;
  public imagePath: any;
  public dynamicData: DynamicData = new DynamicData;
  public fileSizeError = false;
  public menu = 'user';

  public remainingText_it;
  public remainingText_de;
  public remainingText_en;
  public maxLengthText = 1000;
  private _errorTextLenght = false;

  public icons: { [name: string]: any } = {
    'faLink': faLink
  };

  private _imageToUpload: File = null;
  private _organization: Organization;

  constructor(private _activatedRoute: ActivatedRoute, private _dynamicDataService: DynamicDataService, private _lightbox: Lightbox,
    private _toastService: ToastService, private _sharedService: SharedService, private _router: Router) {

      this._toastService.remove();
     }

  ngOnInit(): void {
    const routeParams = this._activatedRoute.snapshot.params;
    if (parseInt(localStorage.getItem('orgId'), 10) === 5 || parseInt(localStorage.getItem('orgId'), 10) === 6 ||
      parseInt(localStorage.getItem('orgId'), 10) === 7) {
      this.menu = 'vss';
    }
    if (!routeParams.orgId) {
      this._router.navigate(['/']);
    }

    this.orgId = routeParams.orgId;

    this._sharedService.getOrganization(routeParams.orgId).subscribe(requestResult => {
      this._organization = requestResult;
      this._sharedService.organizationNameSubject.next({ 'de': this._organization.name_de, 'it': this._organization.name_it });
    }, requestError => {
      console.log(requestError);
    });

    this._dynamicDataService.getDynamicData(this.orgId).subscribe(() => { }, error => { console.log(error); });
    this._dynamicDataService.dynamicDataSubject.subscribe(result => {
      this.dynamicData = result;
      this.imagePath = (result.file ? result.file : null);
      this.countTextLength('it', result.comment_it);
      this.countTextLength('en', result.comment_en);
      this.countTextLength('de', result.comment_de);
    });
  }


  handleImageFileInput(event: any) {
    const files = event.target.files;
    if (files.length === 0) { return; }
    if (files.length > 1) { return; }
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // return this._toastr.warning(this._translate.instant('event.advertiseEvent.imageError'));
    }
    if (files[0].size > 9500000) {
      this.fileSizeError = true;
      return;
    }
    const reader = new FileReader();
    this._imageToUpload = files.item(0);
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagePath = reader.result;
    };
  }

  onUploadImageButtonClick() {
    if (this._imageToUpload) {
      const imageFileNameArray = this._imageToUpload.name.split('.');
      const imageNameFinale = imageFileNameArray[imageFileNameArray.length - 1].toLocaleLowerCase();
      const imageName = Math.random().toString(36).slice(-8) + '.' + imageNameFinale;
      this._dynamicDataService.submitDynamicImage(this._imageToUpload, imageName, this.orgId)
        .subscribe(() => {
          this._toastService.show('', {
            classname: 'bg-success text-light',
            delay: 2000,
            autohide: true,
          });
        }, responseError => {
          // TODO: error toaster
          console.error('Image Upload :: ', responseError);
        });
    }
  }

  openLightbox() {
    this._lightbox.open([{
      src: this.imagePath,
      caption: '',
      thumb: this.imagePath
    }], 0);
  }

  onCommentSaveButtonClick() {
    if (!this._errorTextLenght) {
      this._dynamicDataService.submitDynamicComments(this.dynamicData.comment_it, this.dynamicData.comment_de,
        this.dynamicData.comment_en, this.orgId)
        .subscribe(() => {
          this._toastService.show('', {
            classname: 'bg-success text-light',
            delay: 2000,
            autohide: true,
          });
        }, error => {
          console.log(error);
        });
    } else {
      this._toastService.show('GENERAL.TOAST.errorQuillMaxLenght', {
        classname: 'bg-danger text-light',
        delay: 3000,
        autohide: true,
      });
    }
  }

  deleteImage() {
    this._dynamicDataService.deleteImage(this.orgId).subscribe(() => { });
  }

  changedEditor(lang: string, event: EditorChangeContent) {
   this.countTextLength(lang, event.html, 1);
  }

  countTextLength(lang: string, myText: string, mode: number = 0) {
    if (!myText && mode === 0) { myText = ''; }
    if (myText) {
      if (lang === 'it') {
        this.remainingText_it = this.maxLengthText - myText.length;
      }
      if (lang === 'en') {
        this.remainingText_en = this.maxLengthText - myText.length;
      }
      if (lang === 'de') {
        this.remainingText_de = this.maxLengthText - myText.length;
      }
      this._errorTextLenght  = (this.remainingText_it < 0) || (this.remainingText_en < 0) || (this.remainingText_de < 0);
    }
  }

}
